import React, { ReactNode } from "react";

import { ScrollContainer } from "@common/components/ScrollContainer/ScrollContainer";

import * as Styled from "./TicketDetailsContainer.styles";

export const TicketDetailsContainer = ({ children }: { children: ReactNode }) => {
  return (
    <Styled.TicketDetailsPane>
      <Styled.DetailsPaneWrap>
        <ScrollContainer>
          <div>{children}</div>
        </ScrollContainer>
      </Styled.DetailsPaneWrap>
    </Styled.TicketDetailsPane>
  );
};
